"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const dxp_ai_client_1 = require("@squiz/dxp-ai-client");
const dxp_ai_client_react_1 = require("@squiz/dxp-ai-client-react");
const react_1 = require("react");
const components_1 = require("../../../components");
const constants_1 = require("../../../constants");
const hooks_1 = require("../../../hooks");
const ModalContent = ({ aiServiceOverride, content, contentTool, dialogContentProps, onInsertAfter, onReplace, }) => {
    // FIXME: when this package is used in the FTE is gets nothing back from the hook
    // quick solution was to just allow passing in of an existing aiService context
    const aiServiceHook = (0, dxp_ai_client_react_1.useAiService)();
    const aiService = aiServiceOverride ?? aiServiceHook;
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const { errorMessage, loading, outputContent, resetStore, setErrorMessage, setLoading, setOutputContent, setThreadId, } = (0, hooks_1.useStore)();
    const onInsertAfterClick = (0, react_1.useCallback)(() => {
        onInsertAfter(outputContent);
        dialogContentProps?.close();
    }, [dialogContentProps, onInsertAfter, outputContent]);
    const onReplaceClick = (0, react_1.useCallback)(() => {
        onReplace(outputContent);
        dialogContentProps?.close();
    }, [dialogContentProps, onReplace, outputContent]);
    (0, react_1.useEffect)(() => {
        dialogContentProps?.setButtons([
            (0, jsx_runtime_1.jsx)(components_1.CancelButton, { onClick: dialogContentProps.close }, 'btn-cancel'),
            (0, jsx_runtime_1.jsx)(components_1.InsertAfterButton, { disabled: loading || !!errorMessage, onClick: onInsertAfterClick }, 'btn-insert-after'),
            (0, jsx_runtime_1.jsx)(components_1.ReplaceButton, { disabled: loading || !!errorMessage, onClick: onReplaceClick }, 'btn-replace'),
        ]);
    }, [dialogContentProps, errorMessage, loading, onInsertAfterClick, onReplaceClick, setThreadId]);
    dialogContentProps?.setButtonKeys(['btn-cancel', 'btn-insert-after', 'btn-replace']);
    const executor = (0, react_1.useMemo)(() => {
        return new dxp_ai_client_1.GenerativeCommandExecutor(aiService.apiClient);
    }, [aiService]);
    const generate = (0, react_1.useCallback)(async (content) => {
        if (loading || loaded) {
            return;
        }
        resetStore();
        setLoading(true);
        executor
            .execute(contentTool.id, 'processMessage', {
            IsPreview: false,
            Query: content,
        })
            .then((result) => {
            // Thread doesn't exist on the type from the package :sadge:
            const outputs = result.outputs;
            const thread = outputs.Thread;
            switch (result.status) {
                case 'succeeded':
                    setOutputContent(result.outputs.Message.Response);
                    setThreadId(thread.id);
                    break;
                case 'cancelled':
                case 'failed':
                    setErrorMessage(result.status === 'cancelled' ? constants_1.AI_STRINGS.executionCancelled : constants_1.AI_STRINGS.executionFailed);
                    break;
            }
        })
            .catch(() => {
            setErrorMessage(constants_1.AI_STRINGS.executionFailed);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [contentTool, executor, loaded, loading, resetStore, setErrorMessage, setLoading, setOutputContent, setThreadId]);
    (0, react_1.useEffect)(() => {
        if (!loaded) {
            generate(content);
        }
    }, [content, generate, loaded]);
    (0, react_1.useEffect)(() => {
        if (!loaded && !loading) {
            setLoaded(true);
        }
    }, [loaded, loading]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "dxp-ctm-content", children: [(0, jsx_runtime_1.jsx)(components_1.InputContentContainer, { content: content }), (0, jsx_runtime_1.jsx)(components_1.OutputContentContainer, { isLoading: loading, content: outputContent, errorMessage: errorMessage })] }));
};
exports.ModalContent = ModalContent;
